export default {
  'app.welcome.aeroSUITE': 'Welcome to aeroSUITE',
  'app.welcome.accelAero': 'Welcome to AccelAero',
  'text.or': 'OR',
  'app.onlyValue': '{ value } ',
  'btn.addNew': 'Add New { value }',
  'btn.cancel': 'Cancel',
  'btn.accept': 'Accept',
  'btn.save': 'Save',
  'btn.activate': 'Activate',
  'btn.deactivate': 'Deactivate',
  'btn.duplicate': 'Duplicate',
  'btn.delete': 'Delete',
  'btn.saveChanges': 'Save Changes',
  'btn.createChanges': 'Create Changes',
  'btn.changePassword': 'Change Password',
  'btn.add': 'Add',
  'btn.edit': 'Edit',
  'btn.view': 'View',
  'btn.search': 'Search',
  'btn.skip': 'Skip',
  'btn.next': 'Next',
  'btn.iAgreeTo': 'I agree to',
  'btn.termsAndConditions': 'Terms and Conditions',
  'btn.privacyPolicy': 'Privacy Policy',
  'btn.termsOfUse': 'Terms of use ',
  'btn.help': 'Help',
  'btn.requestResetLink': 'Request Reset Link',
  'btn.forceUserActivate': 'Force User Activate',

  'btnWithParams.edit': 'Edit { value }',
  'btnWithParams.save': 'Save { value }',
  'btnWithParams.duplicate': 'Duplicate { value }',
  'btnWithParams.delete': 'Delete { value }',

  'placeholder.search': 'Search { value }',
  'placeholder.noResults': 'No results found',
  'placeholder.noData': 'No Data',
  'placeholder.success': 'Success!',
  'placeholder.password': 'Password',
  'placeholder.checkEmail': 'Please check your email',
  'placeholder.didNotRecieveEmail': 'Did not receive the email?',
  'placeholder.enterEmailAddress': 'Please enter email address',
  'placeholder.enterUsername': 'Please enter username',
  'placeholder.enterCorrectEmailAddress': 'Please enter correct email address',
  'placeholder.enterCorrectUsername': 'Please enter correct username',
  'placeholder.pleaseEnterEmailAddress': 'Please enter email',
  'placeholder.pleaseEnterUsername': 'Please enter username',
  'form.label.emailAddress': 'Email Address'
};
